module.exports = __webpack_public_path__ + "images/fa-oth-certificate.webp";